import { render, staticRenderFns } from "./SourceSelectionModal.vue?vue&type=template&id=64b31ac0&scoped=true"
import script from "./SourceSelectionModal.vue?vue&type=script&lang=js"
export * from "./SourceSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./SourceSelectionModal.vue?vue&type=style&index=0&id=64b31ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b31ac0",
  null
  
)

export default component.exports